// src/services/AdminWS.js
import axios from "axios";
import qs from "qs";
import { useAuthStore } from "@/stores/authStore";

// const BASE_URL = "http://192.168.0.17:7777";
const BASE_URL = "https://api.glxysims.com";
// const BASE_URL = "https://glxysims.com/api";

// Create an axios instance with default settings.
const instance = axios.create({
  baseURL: BASE_URL,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
});

// Use localStorage to get the token and attach it.
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      console.log("Attaching token to request");
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.log("No token found");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      console.log("Unauthorized, logging out");
      const authStore = useAuthStore();
      authStore.logout();
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export const AdminWS = {
  login(username, password) {
    return instance
      .post("/login", null, { params: { username, password } })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error logging in:", error);
        throw error;
      });
  },

  loadPacks() {
    return instance
      .get("/admin/packs")
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error loading packs:", error);
        throw error;
      });
  },

  getMyIp() {
    return instance
      .get("/admin/my-ip")
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching IP:", error);
        throw error;
      });
  },

  uploadImage(file) {
    const formData = new FormData();
    formData.append("image", file);
    return instance
      .post("/admin/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error uploading image:", error);
        throw error;
      });
  },

  addGalleryItem(data) {
    return instance
      .post("/admin/add-gallery-item", null, { params: data })
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error adding gallery item:", error);
        throw error;
      });
  },
  getUsageStats() {
    return instance
      .get("/admin/usage-stats")
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error fetching usage stats:", error);
        throw error;
      });
  },

  updateVideos() {
    return instance
      .post("/admin/update-videos")
      .then((response) => response.data)
      .catch((error) => {
        console.error("Error updating videos:", error);
        throw error;
      });
  },
};
